<div class="col full-height layout-row"
     [ngClass]="{'selected': isSelected}"
     (mouseenter)="onHover(true)"
     (mouseleave)="onHover(false)"
     (click)="onClick($event)"
>

  <!--  <div *ngIf="item.handle"-->
  <!--    class="drag-handle align-self-center mx-3 my-0"-->
  <!--    dndHandle-->
  <!--    matListItemIcon>-->
  <!--    <bringoz-icon icon-name="account"></bringoz-icon>-->
  <!--  </div>-->

  <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')" class="layout-column">

    <!--    <ng-container>-->
    <!--      <div class="flex layout-column layout-align-start-center margin-left-8 margin-right-10" style="position: relative">-->
    <!--        <div class="drag-wrapper">-->
    <!--          <ng-content></ng-content>-->
    <!--        </div>-->
    <!--        <div class="activity-index"-->
    <!--             [style.border-color]="routeColor"-->
    <!--             [style.background]="highlightedActivity?.id === activity.id ? routeColor : (routeColor + 20)"-->
    <!--             [style.color]="highlightedActivity?.id === activity.id ? 'white' : routeColor"-->
    <!---->
    <!--          <span class="index">{{ index }}</span>-->
    <!--          <span *ngIf="isDisplayRetrips" class="trip-number">{{ activity.tripNumber }}</span>-->
    <!--        </div>-->
    <!--        <div class="flex"></div>-->
    <!--      </div>-->
    <!--    </ng-container>-->

    <ng-container>
      <div *ngIf="isHover || isSmallScreen"
           class="flex layout-column layout-align-start-center margin-left-8 margin-right-10"
           style="position: relative">
        <div class="drag-lock-row"
             [ngClass]="{'margin-bottom-5': route.locked || isActivityLocked}">
          <div class="drag-wrapper" [ngClass]="{'beside-lock': route.locked || isActivityLocked}">
            <ng-content></ng-content>
          </div>
          <bringoz-icon *ngIf="route.locked" iconName="lock" classSize="lg"
                        fill="#484848"
                        [ngbTooltip]="'Route is Locked' | translate"
                        container="body"
                        openDelay="300">
          </bringoz-icon>
          <bringoz-icon *ngIf="isActivityLocked && !route.locked" iconName="lock" classSize="lg"
                        fill="#484848"
                        [ngbTooltip]="'Job is Locked' | translate"
                        container="body"
                        openDelay="300">
          </bringoz-icon>
        </div>
        <div class="flex">
          <!--          <bringoz-icon iconName="drag" fill="#484848"></bringoz-icon>-->
        </div>
        <div class="activity-index layout-column layout-align-center-center"
             [ngClass]="activity.stopType"
             [style.border-color]="routeColor"
             [style.background]="highlightedActivity?.id === activity.id ? routeColor : (routeColor + 20)"
             [style.color]="highlightedActivity?.id === activity.id ? 'white' : routeColor"
        >
          <span class="index">{{ index }}</span>
          <span *ngIf="isDisplayRetrips" class="trip-number">{{ activity.tripNumber }}</span>
        </div>
        <div class="flex"></div>
      </div>

      <div *ngIf="!isHover && !isSmallScreen"
           class="flex layout-column layout-align-start-center margin-left-8 margin-right-10">
        <bringoz-icon *ngIf="route.locked" iconName="lock" classSize="lg"
                      class="margin-bottom-5"
                      fill="#484848"
                      [ngbTooltip]="'Route is Locked' | translate"
                      openDelay="300">
        </bringoz-icon>
        <bringoz-icon *ngIf="isActivityLocked && !route.locked" iconName="lock" classSize="lg"
                      class="margin-bottom-5"
                      fill="#484848"
                      [ngbTooltip]="'Job is Locked' | translate"
                      container="body"
                      openDelay="300">
        </bringoz-icon>
        <div class="flex index-border" [style.background-color]="routeColor"></div>
        <div class="activity-index layout-column layout-align-center-center"
             [ngClass]="activity.stopType"
             [style.border-color]="routeColor"
             [style.background]="highlightedActivity?.id === activity.id ? routeColor : (routeColor + 20)"
             [style.color]="highlightedActivity?.id === activity.id ? 'white' : routeColor"
        >
          <span class="index">{{ index }}</span>
          <span *ngIf="isDisplayRetrips" class="trip-number">{{ activity.tripNumber }}</span>
        </div>
        <div class="flex index-border" [style.background-color]="routeColor"></div>
      </div>
    </ng-container>

  </div>

  <div class="flex layout-row layout-wrap">

    <!--Link Row-->
    <div class="flex-100 layout-row layout-align-start-center gap-5">
      <app-bringoz-checkbox
        appBringozIdGenerator="checkbox-task-route-drill-down"
        *ngIf="route.status !== 'DISPATCHED' && (activity.type !== 'START') && (activity.type !== 'END')"
        [isChecked]="isSelected"
        [isDisabled]="route?.locked || isRunning"
        [ngbTooltip]="isSelected ? ('Deselect Activity' | translate) : ('Select Activity' | translate)"
        openDelay="300"
        (clickEvent)="onToggle.emit(!isSelected)">
      </app-bringoz-checkbox>

      <app-bringoz-state-link *ngIf="settings?.columns?.id && (job?.orderId && activity.type !== 'GROUP')"
                              class="text-ellipsis"
                              [appHighlightText]="queryText"
                              [state]="'order.info'"
                              [params]="{id : job?.orderId}"
                              [text]="job.externalId || job.orderId">
      </app-bringoz-state-link>

      <span *ngIf="settings.columns?.type && activity.type === 'GROUP'"
            class="bundle-header br-body-1"
            [appHighlightText]="queryText"
            [ngClass]="activity.stopType">
        {{ 'Multi' | translate }} {{ activity.stopType | translate }}({{ activity.stopIds.length }})
      </span>

      <span *ngIf="settings.columns?.type && activity.type !== 'GROUP'"
            class="bundle-header br-body-1"
            [appHighlightText]="queryText"
            [ngClass]="activity.stopType">
        {{ activity.stopType | translate }}
      </span>

      <bringoz-button *ngIf="job && activity.type !== 'GROUP'"
                      appBringozIdGenerator="info-task-route-drill-down"
                      type="tertiary"
                      size="fit"
                      [ngbTooltip]="'View Job Details' | translate"
                      openDelay="300"
                      (onClick)="onViewJob.emit({jobs: [job], event: $event})">
        <bringoz-icon iconName="info-outline" classSize="md" fill="#484848"></bringoz-icon>
      </bringoz-button>

      <bringoz-button *ngIf="jobs && activity.type === 'GROUP'"
                      appBringozIdGenerator="info-task-route-drill-down"
                      type="tertiary"
                      size="fit"
                      [ngbTooltip]="'View Job Details' | translate"
                      openDelay="300"
                      (onClick)="onViewJob.emit({jobs: jobs, event: $event})">
        <bringoz-icon iconName="info-outline" classSize="md" fill="#484848"></bringoz-icon>
      </bringoz-button>

      <bringoz-icon *ngIf="!!lastSyncedFromStepAt"
                    iconName="synced"
                    classSize="md"
                    [ngbTooltip]="('Synced' | translate) + ': ' + ({lastSyncedFromStepAt: lastSyncedFromStepAt} | bringozFullDate: 'lastSyncedFromStepAt') + ' ' + ({lastSyncedFromStepAt: lastSyncedFromStepAt} | bringozTime: 'lastSyncedFromStepAt')"
                    openDelay="300">
      </bringoz-icon>

      <span class="flex"></span>

      <div
        *ngIf="(isShowObligateTimeWindowToggle || isObligatedTimeWindow) && (activity.type !== 'START') && (activity.type !== 'END')"
        type="tertiary"
        class="pointer"
        appBringozIdGenerator="priority-task-route-drill-down"
        (mouseenter)="isHighlightObligateTimeWindowToggle=true"
        (mouseleave)="isHighlightObligateTimeWindowToggle=false"
        (click)="onToggleObligateTimeWindow.emit({jobIds: jobIds, obligateTimeWindow: !isObligatedTimeWindow})">

        <div *ngIf="isHighlightObligateTimeWindowToggle">
          <bringoz-icon *ngIf="isObligatedTimeWindow" iconName="toggle-on-hover"
                        [ngbTooltip]="'Guarantee' | translate"
                        openDelay="300"
                        triggers="hover"
                        container="body"></bringoz-icon>
          <bringoz-icon *ngIf="!isObligatedTimeWindow"
                        iconName="toggle-off-hover"
                        [ngbTooltip]="'Set Guarantee' | translate"
                        openDelay="300"
                        triggers="hover"
                        container="body"></bringoz-icon>
        </div>

        <div *ngIf="!isHighlightObligateTimeWindowToggle">
          <bringoz-icon *ngIf="isObligatedTimeWindow" iconName="toggle-on"
                        [ngbTooltip]="'Guarantee' | translate"
                        openDelay="300"></bringoz-icon>
          <bringoz-icon *ngIf="!isObligatedTimeWindow" iconName="toggle-off"
                        [ngbTooltip]="'Set Guarantee' | translate"
                        openDelay="300"></bringoz-icon>
        </div>

      </div>

      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')" ngbDropdown container="body">
        <bringoz-button type="tertiary"
                        size="fit"
                        id="activity-action-menu-{{activity.id}}"
                        (click)="$event.stopPropagation();"
                        ngbDropdownToggle>
          <bringoz-icon iconName="menu" class="gray-102"></bringoz-icon>
        </bringoz-button>
        <div ngbDropdownMenu [attr.aria-labelledby]="'activity-action-menu-' + activity.id">
          <button
            ngbDropdownItem
            type="tertiary"
            [disabled]="route?.locked"
            (click)="onToggleLockJobs.emit({jobIds: jobIds, isLocked: !isActivityLocked});$event.stopPropagation()">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon [iconName]="isActivityLocked ? 'lock-open-outline' : 'lock'" class="gray-102 margin-right-10" classSize="xl"></bringoz-icon>
              <span class="br-body-2">{{(isActivityLocked ? 'Unlock' : 'Lock') | translate}}</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!--Start/End Row-->
    <div *ngIf="(activity.type === 'START') || (activity.type === 'END')"
         [ngClass]="{'flex-100': itemElementSize === 'large', 'flex-50': itemElementSize === 'medium'}"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="location-pin-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="activity.type === 'START' ? ('Start Location' | translate) : ('End Location' | translate)"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1" [appHighlightText]="queryText">{{ 'STOP_PURPOSE.' + activity.type | translate }}</span>
    </div>

    <!--Account Row-->
    <div
      *ngIf="settings?.columns?.account && (activity.type !== 'START') && (activity.type !== 'END')"
      class="layout-row layout-align-start-center info-row gap-5 flex-100">
      <bringoz-icon iconName="account"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Account' | translate"
                    openDelay="300">

      </bringoz-icon>

      <app-bringoz-items-list-display [appHighlightText]="queryText"
                                      [items]="accountsName"
                                      [isTransparentBackground]="true"
                                      [maxItems]="1">
      </app-bringoz-items-list-display>

    </div>


    <!--Vehicles-->
    <div *ngIf="settings?.columns?.vehicles && job"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5 text-ellipsis ">
        <bringoz-icon iconName="privatecar"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Vehicles' | translate"
                      placement="top"
                      openDelay="300">
        </bringoz-icon>
        <app-bringoz-items-list-display [itemsList]="{list: job.allowedVehicleReferences, displayKey: 'name'}"
                                        maxItems="1">
        </app-bringoz-items-list-display>
    </div>

    <!--Address Row-->
    <div
      *ngIf="settings?.columns?.address && (activity.type !== 'START') && (activity.type !== 'END')"
      class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <!--      <bringoz-icon iconName="location-pin-outline"-->
      <!--                    classSize="md"-->
      <!--                    fill="#484848"-->
      <!--                    [fill]="activity.stopType === 'Pickup' ? '#FF9936' : (activity.stopType === 'Dropoff' ? '#2196F3': '#2EBDA4')"-->
      <!--                    [ngbTooltip]="'Address' | translate"-->
      <!--       >-->

      <!--      </bringoz-icon>-->
      <div class="flex td small layout-row layout-align-start-center"
           (mouseenter)="showAddressIcon=true"
           (mouseleave)="showAddressIcon=false">
        <app-task-purpose [purpose]="activity.stopType" firstLetterOnly="true"></app-task-purpose>
        <span class="br-body-1 text-ellipsis"
              [appHighlightText]="queryText"
              [ngbTooltip]="activity.address | bringozAddress"
              openDelay="300">{{ activity.address | bringozAddress }}</span>

        <app-address-quality
          *ngIf="isValidAddressType(activity.address) && (showAddressIcon || !isHighQualityAddress(activity.address))"
          [query]="query"
          [type]="type" [address]="activity.address.addressResolvingInfo">
        </app-address-quality>
        <ng-template #locationTooltip>
          <div class="layout-column layout-align-start-center">
            <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Address' | translate }}
                  : {{ activity.address | bringozAddress }}</span>
              <div class="layout-column layout-align-start-center">
                  <span class="br-body-2 margin-right-10">{{ 'Floor' | translate }}
                    : {{ job.address.floor || '--' }}</span>
                <span class="br-body-2">{{ 'Apt' | translate }}: {{
                    activity.address.apartment || '--'
                  }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow && stopRef"
         [ngClass]="{'flex-100': itemElementSize === 'large', 'flex-50': itemElementSize === 'medium'}"
         class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="time-window-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Time Window' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis" [appHighlightText]="queryText">{{ stopRef | timeWindow }}</span>
    </div>

    <!--Time Estimations Row-->
    <div *ngIf="settings?.columns?.timeEstimations"
         [ngClass]="{'flex-100': itemElementSize === 'large', 'flex-50': itemElementSize === 'medium'}"
         class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'ETA / ETD' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis"
            [appHighlightText]="queryText">{{ activity | planningActivityTimeWindow }}</span>
    </div>

    <!--Service Time Row-->
    <div
      *ngIf="settings?.columns?.serviceTime && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Service Time' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span *ngIf="!activity.detailedServiceTime"
            class="br-body-1 text-ellipsis"
            [appHighlightText]="queryText">{{ activity.serviceTime | bringozTimeConvert:true }}</span>

      <app-task-detailed-service-time *ngIf="!!activity.detailedServiceTime"
                                      [fontSize]="'br-body-1'"
                                      [isAllowEdit]="false"
                                      [appHighlightText]="queryText"
                                      [detailedServiceTime]="activity.detailedServiceTime">
      </app-task-detailed-service-time>
    </div>


    <!--Service Time Row-->
    <div
      *ngIf="settings?.columns?.distance && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="distance"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Distance From Last Stop' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis"
        [appHighlightText]="queryText">{{ activity.distanceFromLastStopMeter | bringozDistance: '---':true }}</span>
    </div>

    <!--Contacts Row-->
    <div
      *ngIf="settings?.columns?.contacts && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="contact-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Contacts' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis" [appHighlightText]="queryText">{{ stopRef?.contact?.name || '---' }}</span>
    </div>

    <!--SLA Row-->
    <div *ngIf="settings?.columns?.sla && (activity.type !== 'START') && (activity.type !== 'END')"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row info-row layout-align-start-center gap-5 text-ellipsis">
      <span class="br-body-1 fon-weight-600"
            [ngbTooltip]="'Service Level Agreement' | translate"
            openDelay="300">SLA</span>
      <span class="br-body-1" [appHighlightText]="queryText">{{ job | bringozDate: 'sla' }}</span>
      <span class="br-body-1" [appHighlightText]="queryText">{{ job | bringozTime: 'sla' }}</span>
    </div>

    <!--Labels Row-->
    <div
      *ngIf="settings?.columns?.labels && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="label-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-labels-display [labels]="labels"
                                  [appHighlightText]="queryText"
                                  maxItems="1">

      </app-bringoz-labels-display>
      <span *ngIf="!labels?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Packages Row-->
    <div
      *ngIf="settings?.columns?.packages && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-packages-items-display-list class="flex"
                                               [appHighlightText]="queryText"
                                               [items]="packages">

      </app-bringoz-packages-items-display-list>
    </div>

    <!--Barcodes Row-->
    <div
      *ngIf="settings?.columns?.barcodes && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="barcode"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Barcodes' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-items-list-display [items]="barcodesList"
                                      [appHighlightText]="queryText"
                                      maxItems="1"></app-bringoz-items-list-display>
    </div>

    <!--Recurring Service template ID-->
    <div
      *ngIf="!!job?.serviceTemplateId && settings?.columns?.recurringServiceTemplateId && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="recurring" class="gray-102" classSize="lg"
                    [ngbTooltip]="'Recurring Service Template' | translate"
                    openDelay="300"></bringoz-icon>
      <app-bringoz-state-link class="text-ellipsis"
                              [state]="'recurring-services'"
                              [permission]="'recurring-service-template.list'"
                              [appHighlightText]="queryText"
                              [params]="{queryString: job.serviceTemplateId}"
                              [text]="job.serviceTemplateId">
      </app-bringoz-state-link>
    </div>

    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight && (activity.type !== 'START') && (activity.type !== 'END')"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="weight"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis"
        [appHighlightText]="queryText">{{ activity.packages | planningPackagesWeightPipe:true }}</span>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume && (activity.type !== 'START') && (activity.type !== 'END')"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="volume"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis"
        [appHighlightText]="queryText">{{ activity.packages | planningPackagesVolumePipe: true }}</span>
    </div>

    <!--Load - Packages-->
    <div
      *ngIf="settings?.load?.packages && (activity.type !== 'START') && (activity.type !== 'END')"
      [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
      class=" layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="package-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis"
            [appHighlightText]="queryText">{{ activity.packages | planningPackagesPipe:false }}</span>
    </div>

    <!--Load - Value-->
    <div *ngIf="settings?.load?.value && (activity.type !== 'START') && (activity.type !== 'END')"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="dollar-circle"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Value' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis" [appHighlightText]="queryText">{{ job?.price | bringozPrice }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets && (activity.type !== 'START') && (activity.type !== 'END')"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="pallets"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis"
        [appHighlightText]="queryText">{{ activity.packages | planningPackagesPalletsPipe: false }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots && (activity.type !== 'START') && (activity.type !== 'END')"
         [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
         class="layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="spot"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span
        class="br-body-1 text-ellipsis"
        [appHighlightText]="queryText">{{ activity.packages | planningPackagesSpotsPipe: true }}</span>
    </div>

    <!--    &lt;!&ndash;Capacity Row&ndash;&gt;-->
    <!--    <div *ngIf="settings?.capacity && capacity" class=" layout-row layout-align-start-center info-row gap-5">-->
    <!--      <bringoz-icon [iconName]="capacity.icon"-->
    <!--                    classSize="md">-->

    <!--      </bringoz-icon>-->
    <!--      <app-bringoz-capacity-bar class="flex" [value]="capacity.percentage">-->

    <!--      </app-bringoz-capacity-bar>-->
    <!--      <span class="br-body-1">{{capacity.percentage}}%</span>-->
    <!--    </div>-->


  </div>

</div>
